import { connect } from 'react-redux';

import { getUserContext as getUserContextSelector } from 'selectors/user/userSelectors';
import { getNav } from 'actions/NavActions';
import { getUserContext } from 'actions/UserActions';

import UnifiedNav from './UnifiedNav';

const mapStateToProps = state => ({
  userContext: getUserContextSelector(state),
});

const mapDispatchToProps = dispatch => ({
  fetchUserContext: () => dispatch(getUserContext()),
  onGetNav: () => dispatch(getNav())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnifiedNav);



// WEBPACK FOOTER //
// ./src/components/common/header/UnifiedNav/index.js